export default __webpack_public_path__ + "static/media/bg.b3fdca8c.svg";